<p-dialog [visible]="true" [breakpoints]="{'500px': '100%'}" [style]="{width: '50%'}" [baseZIndex]="10000"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false"
  [ngClass]="{'change-scrollbar-color-darkMode': settings.darkModeSetting, 'change-scrollbar-color': !settings.darkModeSetting}">
  <ng-template [ngIf]="!showConfirmation">
    <dialog-header [title]="action.name" [settings]="settings" [icon]="faPen"></dialog-header>
    <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div [ngClass]="!mobileView ? 'offset-1 col-10' : 'col-12'">
        <div *ngFor="let row of paramRows" class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
          <div class="animated fadeIn" *ngFor="let rowItem of row"
            [ngClass]="!rowItem.param.position ? 'col-12' : getColClasses(rowItem)">
            <div class="flex animated fadeIn align-end" style="height: 35px;">
              <ng-template [ngIf]="rowItem.param.type == 'divider' && rowItem.param.caption != ''">                
                <div class="dividers">
                  <span class="textGreen" [ngClass]="['font' + settings.textSizeSetting]">
                    {{rowItem.param.caption}}
                  </span>
                </div>                
              </ng-template>
              <ng-template [ngIf]="rowItem.param.type != 'divider'">
                <span [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]">
                  {{rowItem.param.caption}}
                </span>
              </ng-template>              
              <ng-template [ngIf]="rowItem.param.mandatory == 'Y'">
                <span class="font12 italic" style="transform: translateX(10px);"
                  [ngClass]="settings.darkModeSetting ? 'textGreyb9' : 'textBlack'">
                  {{app.translations.GBL_lbl_Required}}</span>
              </ng-template>
            </div>
            <ng-template [ngIf]="rowItem.param.type == 'multiselect'">
              <div class="animated fadeIn" (click)="opMulti.toggle($event)" tabindex="0"
                (focus)="opMulti.toggle($event)">
                <div class="form-control relative flex" style="padding-right: 40px;">
                  <div class="flex" style="overflow-x: auto !important; overflow-y: hidden;">
                    <span #optionEl *ngFor="let item of rowItem.param.multiValueArray"
                      class="b-radius textWhite multi-select-item relative"
                      [ngClass]="'font' + settings.textSizeSetting">
                      {{item}}
                      <fa-icon [icon]="faXmark"
                        class="bg-none multi-select-item-unselect cursorPointer textWhite absolute"
                        (click)="unselectOption(item, rowItem.param)"
                        [ngClass]="'font' + settings.textSizeSetting"></fa-icon>
                    </span>
                  </div>
                  <fa-icon [icon]="faListCheck" class="absolute bg-none combo-input-icon cursorPointer padding5"
                    (click)="opMulti.toggle($event);"
                    [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"></fa-icon>
                </div>
                <p-overlayPanel #opMulti [styleClass]="getOverlayPanelWidth(rowItem)">
                  <ng-template pTemplate="content" class="full-width unset-p">
                    <div class="combo-options-container b-radius p-unset overflow-auto full-width"
                      [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                      <div #optionEl *ngFor="let item of rowItem.param.filteredLookupValues; let i = index"
                        class="combo-option poppins relative"
                        [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                        <mat-checkbox [checked]="rowItem.param.value.includes(item.lookUpValue.value)"
                          style="transform: translate(3px, 5px);"
                          (change)="updateMultiSelectCombos($event, rowItem.param, item.lookUpValue.value)">
                        </mat-checkbox>
                        <span class="absolute" style="top: 50%; transform: translate(10px, -50%);">
                          {{ item.lookUpValue.value }}
                        </span>
                      </div>
                      <span
                        *ngIf="rowItem.param.filteredLookupValues && rowItem.param.filteredLookupValues.length === 0"
                        class="combo-option poppins flex justify-centre align-centre"
                        [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                        {{app.translations.GBL_lbl_NoResults}}
                      </span>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type.includes('combo')">
              <div class="animated fadeIn">
                <div class="relative">
                  <input #inputEl class="form-control cursorPointer" type="text" [(ngModel)]="rowItem.param.value"
                    (keyup)="change($event, rowItem.param)" (keydown)="handleKeyDown($event)"
                    (click)="openDropdown($event, rowItem.param, op)" (focus)="openDropdown($event, rowItem.param, op)"
                    (blur)="handleBlur(rowItem.param, op)"
                    [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                    [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
                  <fa-icon [icon]="faChevronDown" class="absolute bg-none combo-input-icon padding5"
                    style="pointer-events: none;"
                    [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"></fa-icon>
                </div>
                <p-overlayPanel #op [styleClass]="getOverlayPanelWidth(rowItem)">
                  <ng-template pTemplate="content" class="full-width unset-p">
                    <div class="combo-options-container b-radius p-unset overflow-auto full-width"
                      [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                      <div #optionEl *ngFor="let item of rowItem.param.filteredLookupValues; let i = index"
                        class="combo-option poppins relative" (mousedown)="updateCombos(false, rowItem.param, item)"
                        [ngClass]="item.selected ? 'bg-green textWhite' : settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                        <span class="absolute" style="top: 50%; transform: translate(10px, -50%);">
                          {{ rowItem.param.type == 'combolookup' ? item.lookUpValue.value : item.lookUpValue }}
                        </span>
                      </div>
                      <span
                        *ngIf="rowItem.param.filteredLookupValues && rowItem.param.filteredLookupValues.length === 0"
                        class="combo-option poppins flex justify-centre align-centre"
                        [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                        {{app.translations.GBL_lbl_NoResults}}
                      </span>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </ng-template>
            <ng-template
              [ngIf]="(rowItem.param.type == 'text' || rowItem.param.type == 'textbox') && (rowItem.param.dataType == 'Int32' || rowItem.param.dataType == 'Int16')">
              <div class="animated fadeIn">
                <input type="number" class="form-control" step="1" pattern="[0-9]*"
                  (change)="updateNumericInputs(rowItem.param, $event)"
                  [value]="selectedItems.length == 1 ? rowItem.param.preselectedValue : ''"
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                  [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
              </div>
            </ng-template>
            <ng-template
              [ngIf]="(rowItem.param.type == 'text' || rowItem.param.type == 'textbox') && (rowItem.param.dataType == 'Decimal' || rowItem.param.dataType == 'Double')">
              <div class="animated fadeIn">
                <input type="number" class="form-control" (change)="updateNumericInputs(rowItem.param, $event)"
                  [value]="selectedItems.length == 1 ? rowItem.param.preselectedValue.replace(',', '.') : ''"
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                  [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
              </div>
            </ng-template>
            <ng-template
              [ngIf]="(rowItem.param.type == 'text' || rowItem.param.type == 'textbox') && rowItem.param.dataType == 'DateTime'">
              <div class="animated fadeIn">
                <input type="text" class="form-control" (change)="updateTextInputs(rowItem.param, $event)"
                  pTooltip="{{settings.dateFormatSetting}}" tooltipPosition="top"
                  [value]="selectedItems.length == 1 ? rowItem.param.preselectedValue : ''"
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                  [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
              </div>
            </ng-template>
            <ng-template
              [ngIf]="(rowItem.param.type == 'date' || rowItem.param.type == 'datebox') && (rowItem.param.dataType == '' || rowItem.param.dataType == 'DateTime')">
              <div class="animated fadeIn" style="z-index: 10 !important;">
                <ng-template [ngIf]="showDateFields">
                  <date-picker (dateSelected)="updateDateInput($event, rowItem.param)" [param]="rowItem.param"
                    [settings]="settings"
                    [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : 'unset' }"></date-picker>
                </ng-template>
              </div>
            </ng-template>
            <ng-template
              [ngIf]="(rowItem.param.type == 'datetime' || rowItem.param.type == 'datetimebox') && (rowItem.param.dataType == '' || rowItem.param.dataType == 'DateTime')">
              <div class="animated fadeIn" style="z-index: 10 !important;">
                <ng-template [ngIf]="showDateFields">
                  <date-picker (dateSelected)="updateDateInput($event, rowItem.param)" [param]="rowItem.param"
                    [settings]="settings"
                    [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : 'unset' }"></date-picker>
                </ng-template>
              </div>
            </ng-template>
            <ng-template
              [ngIf]="(rowItem.param.type == 'time' || rowItem.param.type == 'timebox') && (rowItem.param.dataType == '' || rowItem.param.dataType == 'DateTime' || rowItem.param.dataType == 'TimeSpan')">
              <div class="animated fadeIn">
                <input type="time" class="form-control font13" (change)="updateTextInputs(rowItem.param, $event)"
                  [value]="selectedItems.length == 1 ? rowItem.param.preselectedValue : ''"
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                  [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
              </div>
            </ng-template>
            <ng-template
              [ngIf]="(rowItem.param.type == 'text' || rowItem.param.type == 'textbox') && (rowItem.param.dataType == '' || rowItem.param.dataType == 'String' || rowItem.param.dataType == undefined)">
              <div class="animated fadeIn col-12">
                <input type="text" class="form-control" (change)="updateTextInputs(rowItem.param, $event)"
                  [value]="selectedItems.length == 1 ? rowItem.param.preselectedValue : ''"
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                  [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
              </div>
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type == 'textarea'">
              <div class="animated fadeIn">
                <div class="relative">
                  <textarea class="form-control pre-wrap-white-space transition5"
                    (blur)="updateCombos(true, rowItem.param, $event)" [(ngModel)]="rowItem.param.preselectedValue"
                    (keyup)="updateTextInputs(rowItem.param, $event)" rows="5"
                    style="padding: 5px 25px 5px 5px !important;"
                    [ngStyle]="{'border-color': rowItem.param.errorMessage && rowItem.param.errorMessage.length > 0 || rowItem.param.highlightRequired ? 'var(--red)' : '#ced4da'}"
                    [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"></textarea>
                  <ng-template [ngIf]="rowItem.param.errorMessage && rowItem.param.errorMessage.length > 0">
                    <fa-icon [icon]="faCircleInfo" class="absolute font14 textRed cursorPointer"
                      style="top: 7px; right: 10px;" pTooltip="{{rowItem.param.errorMessage}}"
                      tooltipPosition="top"></fa-icon>
                  </ng-template>
                  <div class="row" style="margin-top: 10px !important;">
                    <div class="col-6 unset-p">
                      <ng-template [ngIf]="validTestedSQL">
                        <span class="textGreen padding5 b-radius"
                          [ngClass]="[settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue', 'font' + settings.textSizeSetting]">
                          {{app.translations.GBL_lbl_SQLTestResult}}
                        </span>
                      </ng-template>
                    </div>
                    <ng-template
                      [ngIf]="(rowItem.param.caption.includes('SQL') || rowItem.param.name.includes('SQL')) && rowItem.param.isParentLookup">
                      <div class="col-6 unset-p">
                        <button class="btn float-right" (click)="testSQL(rowItem.param)" tabindex="-1"
                          [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]">
                          {{app.translations.GBL_btn_TestSQL}}
                        </button>
                        <ng-template [ngIf]="validTestedSQL">
                          <button class="btn float-right animated fadeIn" (click)="showDataPreview = !showDataPreview"
                            [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]">
                            <fa-icon [icon]="faAngleDoubleDown"></fa-icon>
                          </button>
                        </ng-template>
                      </div>
                    </ng-template>
                  </div>
                  <ng-template [ngIf]="showDataPreview">
                    <div style="overflow-x: scroll !important;">
                      <table>
                        <thead>
                          <tr>
                            <th *ngFor="let column of tableColumns" class="padding3">
                              <span
                                [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]">
                                {{ column }}
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of tableData">
                            <td *ngFor="let column of tableColumns" class="padding3 compact-grid cursorPointer"
                              [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                              pTooltip="{{row[column]}}" tooltipPosition="top">
                              <span style="white-space: nowrap">
                                {{ row[column] }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-template>
                </div>
              </div>
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type == 'password'">
              <div class="animated fadeIn">
                <input type="password" autocomplete="new-password" (change)="updateTextInputs(rowItem.param, $event)"
                  class="form-control" [value]="selectedItems.length == 1 ? rowItem.param.preselectedValue : ''"
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"
                  [ngStyle]="{ 'border': rowItem.param.highlightRequired ? '1px solid var(--red)' : '1px solid #9b9b9ba6' }" />
              </div>
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type == 'check' || rowItem.param.type == 'toggle' || rowItem.param.type == 'checkbox'">
              <div class="animated fadeIn">
                <mat-checkbox [checked]="app.tryParseBoolean(rowItem.param.preselectedValue)"
                  (change)="updateCheckboxToggles(rowItem.param, $event)" tabindex="-1"
                  [indeterminate]="rowItem.param.preselectedValue == null">
                </mat-checkbox>
              </div>
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type == 'image' || rowItem.param.type == 'imagebox'">
              <div class="animated fadeIn">
                <label style="margin-right: 15px; margin-top: 15px;" (click)="fileInput.value = ''"
                  pTooltip="{{app.translations.GBL_hint_UploadImage}}" tooltipPosition="top">
                  <fa-icon [icon]="faArrowUpFromBracket" class="font15 cursorPointer b-radius padding10"
                    [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textGreen'"></fa-icon>
                  <input #fileInput type="file" class="display-none" (change)="updateImage(rowItem.param, $event)">
                </label>
                <ng-template [ngIf]="rowItem.param.preselectedValue || selectedItems.length > 1">
                  <button class="font15 cursorPointer b-radius padding10 transition4 unset-b"
                    (click)="updateImage(rowItem.param, undefined)"
                    [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textGreen'">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button><br>
                </ng-template>
                <ng-template [ngIf]="rowItem.param.preselectedValue">
                  <img [src]="app.getFormattedImage(rowItem.param.preselectedValue)" class="b-radius full-width"
                    style="margin-top: 30px; width: 150px;" />
                </ng-template>
              </div>
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type == 'signature'">
              <div class="animated fadeIn">
                <ng-template [ngIf]="!mobileView">
                  <canvas style="border: 1px solid #dee2e6 !important;" #canvas class="b-radius" width="700"
                    height="200"></canvas>
                </ng-template>
                <ng-template [ngIf]="mobileView">
                  <canvas style="border: 1px solid #dee2e6 !important; width: 100% !important;" #canvas class="b-radius"
                    height="200"></canvas>
                </ng-template>
                <div class="buttons flex justify-between">
                  <button (click)="clearSignature(rowItem.param)" class="btn font13"
                    [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                    {{app.translations.GBL_btn_Clear}}
                  </button>
                  <button (click)="updateSignature(rowItem.param)" class="btn font13"
                    [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                    {{app.translations.GBL_btn_Submit}}
                  </button>
                </div>
              </div>
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type == 'divider' && rowItem.param.caption == ''">
              <div style="border-top: 1px solid var(--green);">
                <br>
              </div>              
            </ng-template>
            <ng-template [ngIf]="rowItem.param.type == 'fileupload'">
              <div class="animated fadeIn">
                <label style="margin-right: 15px; margin-top: 15px;" (click)="artifactInput.value = ''"
                  pTooltip="{{app.translations.GBL_hint_UploadImage}}" tooltipPosition="top">
                  <fa-icon [icon]="faArrowUpFromBracket" class="font15 cursorPointer b-radius padding10"
                    [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textGreen'"></fa-icon>
                  <input #artifactInput type="file" class="display-none" (change)="uploadArtifact(rowItem.param, $event)">
                </label>   
                <ng-template [ngIf]="rowItem.param.preselectedValue">
                  <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textGreen'">
                    {{rowItem.param.preselectedValue}}
                  </span>
                </ng-template>             
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>    
    <ng-template [ngIf]="selectedItems.length > 1 && action.hasEditProc">
      <div class="row padding10" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
        <div class="flex relative bg-orange padding15 align-centre" style="height: 70px; margin-top: 15px;">
          <span [ngClass]="[settings.darkModeSetting ? 'textBlack' : 'textWhite', 'font' + settings.textSizeSetting]">
            <fa-icon [icon]="faTriangleExclamation" style="margin-right: 20px;"></fa-icon>
          </span>
          <span class="align-centre"
            [ngClass]="[settings.darkModeSetting ? 'textBlack' : 'textWhite', 'font' + settings.textSizeSetting]">
            {{selectedItems.length}} {{app.translations.CMD_lbl_UpdateWarning}}
          </span>
        </div>
      </div>
    </ng-template>
    <div class="row sticky dialog-footer-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="col-12 unset-p" style="margin-top: 15px !important;">
        <div class="flex justify-right padding10 dialog-footer">
          <button class="btn font17" (click)="confirm()">
            <fa-icon [icon]="faFloppyDisk" class="textGreen"></fa-icon>
            <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
              {{app.translations.GBL_btn_SaveText}}
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="showConfirmation">
    <div class="row sticky dialog-title-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="col-12 unset-p">
        <div class="flex relative align-centre dialog-title">
          <span class="textGreen font16 b-radius dialog-title-icon"
            [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
            <fa-icon [icon]="faPen"></fa-icon>
          </span>
          <span class="font15"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.CMD_lbl_Title}}</span>
          <div class="absolute" style="right: 15px;">
            <span class="textGreen font16 b-radius dialog-title-icon cursorPointer" (click)="showConfirmation = false"
              [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
              <fa-icon [icon]="faXmark"></fa-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="padding10" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="row">
        <div class="col-6 unset-p">
          <span class="padding5 b-radius"
            [ngClass]="[settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue', 'font' + settings.textSizeSetting]">
            {{app.translations.CMD_lbl_Field}}
          </span>
        </div>
        <div class="col-6 unset-p">
          <span class="padding5 b-radius"
            [ngClass]="[settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue', 'font' + settings.textSizeSetting]">
            {{app.translations.CMD_lbl_NewValue}}
          </span>
        </div>
      </div>
    </div>
    <div class="padding10" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="row">
        <ng-container *ngFor="let param of parameters">
          <ng-template [ngIf]="(param.value && param.value != 'undefined//undefined') || param.value == null">
            <div class="col-6 unset-p">
              <span
                [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]">{{param.caption}}</span>
            </div>
            <div class="col-6 unset-p">
              <ng-template [ngIf]="(param.type == 'image' || param.type == 'imagebox') && param.value != null">
                <img [src]="app.getFormattedImage(param.value)" style="width: 15%;" />
              </ng-template>
              <ng-template [ngIf]="(param.type == 'image' || param.type == 'imagebox') && param.value == null">
                <span
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]">-</span>
              </ng-template>
              <ng-template [ngIf]="param.type != 'image' && param.type != 'imagebox'">
                <span
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]">{{param.value}}</span>
              </ng-template>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <div class="padding10" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="row">
        <div class="flex relative bg-orange b-radius padding15 align-centre" style="height: 70px;">
          <span [ngClass]="[settings.darkModeSetting ? 'textBlack' : 'textWhite', 'font' + settings.textSizeSetting]">
            <fa-icon [icon]="faTriangleExclamation" style="margin-right: 20px;"></fa-icon>
          </span>
          <span class="align-centre"
            [ngClass]="[settings.darkModeSetting ? 'textBlack' : 'textWhite', 'font' + settings.textSizeSetting]">
            {{selectedItems.length}} {{app.translations.CMD_lbl_UpdateWarning}}
          </span>
        </div>
      </div>
    </div>
    <div class="row sticky dialog-footer-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="col-12 unset-p">
        <div class="flex justify-right padding10 dialog-footer">
          <button class="btn font17" (click)="executeSave(); app.showLoader();">
            <fa-icon [icon]="faCheckDouble" class="textGreen"></fa-icon>
            <span
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_btn_ConfirmText}}</span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>